// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
// Components
import InputField from '../CompanyContactUs/CompanyField/CompanyField';
// Helpers
import { required, phoneNumber } from '../../../helpers/reduxFormValidators';
import { supportEmail } from '../../../constants';
import CloudflareCaptcha from '../../CloudflareCaptcha/CloudflareCaptcha';
import { validatePhoneWithSeparateCountryCode } from '../../../utils/validate';
import CAPTCHA_ACTIONS from '../../../helpers/captchaConstants';
// Styles
import * as styles from './ConsultationForm.scss';

class ConsultationForm extends Component {
  state = {
    showCaptcha: false
  }
  componentWillReceiveProps(nextProps) {
    if (!this.props.formSubmitted && nextProps.formSubmitted) {
      this.props.reset();
    }
  }

  handleShowCaptcha = () => {
    this.setState({ showCaptcha: true });
  }

  fetchReCaptchaToken = (evt) => {
    this.props.fetchReCaptchaToken(evt);
  }

  render() {
    const translate = this.props.translate('companyPage', 'contactsForm');

    return (
      <div className={cx(styles.formWrap, this.props.className)}>
        <div className={styles.title}>{this.props.translate('companyPage', 'formTitle')}</div>

        <form
          onFocus={this.handleShowCaptcha}
          onSubmit={this.props.handleSubmit}
          noValidate="noValidate"
        >
          <Field
            field_id={this.props.field_id}
            name="name"
            component={InputField}
            type="text"
            placeholder={`${translate('name').toString()}*`}
            validate={[required]}
            translateForError={this.props.translate('errorFieldMessages')}
            isRtl={this.props.isRtl}
          />

          <Field
            field_id={this.props.field_id}
            name="phone_number"
            component={InputField}
            type="text"
            normalize={value => value.replace(/[\D]/g, '')}
            placeholder={`${translate('phone').toString()}*`}
            validate={(value) => validatePhoneWithSeparateCountryCode(value)}
            translateForError={this.props.translate('errorFieldMessages')}
            isRtl={this.props.isRtl}
          />
          {this.state.showCaptcha && (
            <CloudflareCaptcha
              fetchToken={this.fetchReCaptchaToken}
              action={this.props.isCommunityMember
                ? CAPTCHA_ACTIONS.CONTACT_AGENCY_COMMUNITY
                : CAPTCHA_ACTIONS.CONTACT_AGENCY}
              doReset={(!this.props.formSubmitting && !!this.props.formConsultationError) || this.props.formSubmitted}
            />
            )
          }
          <button disabled={!this.props.captcha || this.props.formSubmitting} className={styles.submit}>
            {this.props.translate('companyPage', 'sendRequest')}
            {this.props.formSubmitting && <i className="icon icon-om-spinner om-pulse" />}
          </button>
        </form>
        {!!this.props.formConsultationError && (
          <p className={styles.message}>
            {translate('submit_fail_message')} <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>
        )}
      </div>
    );
  }
}

ConsultationForm.propTypes = {
  field_id: PropTypes.string,
  locale: PropTypes.string,
  formConsultationError: PropTypes.object,
  translate: PropTypes.func,
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  className: PropTypes.string,
  sharingUrl: PropTypes.string,
  isRtl: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  reset: PropTypes.func,
  fetchReCaptchaToken: PropTypes.func,
  isCommunityMember: PropTypes.bool,
  captcha: PropTypes.string
};

export default reduxForm({
  form: 'Consultation-Form'
})(ConsultationForm);
